import {isMobile, isTouch} from '@/utils/features';

export const GenericMixin = {
  props: {

  },
  data() {
		return {
			isTouch,
		};
  },
  computed: {
	},
  mounted() {

	},
  methods: {
		isMobile() {
			return isMobile();
		},
  }
};

export default GenericMixin;
